import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const SearchCard = ({
  title,
  backgroundImageUrl,
  data,
  slug,
  id,
  titleUrl = ''
}) => {
  const titleContent = titleUrl ? (
    <Link
      href={`/[...search]?url=${slug}${titleUrl}`}
      as={`${slug}${titleUrl}`}
      id={`${id}-category-link`}
    >
      {title}
    </Link>
  ) : (
    title
  );
  const renderLeftItems = (
    <div className="search-card__content_column">
      {data.map((item, i) => {
        if (i < 3) {
          return (
            <Link
              href={`/[...search]?url=${slug}/${item.link}`}
              as={`${slug}/${item.link}`}
              key={item.id}
              id={`${id}-quick-link-${item.id}`}
              className="search-card__link"
            >
              {item.translates}
            </Link>
          );
        }
        return false;
      })}
    </div>
  );
  const renderRightItems = (
    <div className="search-card__content_column">
      {data.map((item, i) => {
        if (i > 2) {
          return (
            <Link
              href={`/[...search]?url=${slug}/${item.link}`}
              as={`${slug}/${item.link}`}
              key={item.id}
              id={`${id}-quick-link-${item.id}`}
              className="search-card__link"
            >
              {item.translates}
            </Link>
          );
        }
        return false;
      })}
    </div>
  );

  return (
    <div
      className="search-card"
      id={id}
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(65, 65, 65, 0.33)), ${backgroundImageUrl}`
      }}
    >
      <h4 className="search-card__title" data-cy="search-card-title">
        {titleContent}
      </h4>
      <div className="search-card__content">
        {renderLeftItems}
        {renderRightItems}
      </div>
    </div>
  );
};

SearchCard.propTypes = {
  title: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  data: PropTypes.array,
  slug: PropTypes.string,
  titleUrl: PropTypes.string,
  id: PropTypes.string
};

export default SearchCard;
